query GetCaseProcessingRecords(
  $dateFrom: ISO8601DateTime
  $dateTo: ISO8601DateTime
) {
  caseProcessingRecords(dateFrom: $dateFrom, dateTo: $dateTo) {
    caseId
    caseRecordType
    caseOwner
    caseNumber
    caseOpened
    caseClosed
    legalEntity
    grantComplexity
    totalTimeTakenInMinutes
    totalTimeTakenInMinutesIncludingNonWorkingTime
    transactionAmount {
      currency
      minorUnit
    }
    recipientName
    recipientType
    stages {
      stageId
      editedBy
      oldValue
      newValue
      editedDate
      timeTakenInMinutes
      timeTakenInMinutesIncludingNonWorkingTime
    }
  }
}
